<template>
  <div style="width: 100%">
    <div class="gaugeContainer" :class="{ 'gauge-compact': compact }">
      <div class="gaugeHeader">
<!--        <font-awesome-icon class="icon" :icon="['fas', icon]" />-->
        <h4>{{ title }}</h4>
      </div>
      <div class="gauge" :id="'gauge' + value">
        <img
            class="gaugeOutline"
            :id="'gaugeOutline' + value"
            src="/static/img/GaugeOutline.svg"
            alt=""
        />
        <img
            class="gaugePin"
            :id="'gaugePin' + value"
            src="/static/img/GaugePin.svg"
            alt=""
        />
      </div>
      <div v-if="showFooter" class="gaugeFooter">
<!--        <label>Score</label>-->
        <h1 v-if="!smallValue">{{ value + ' ' + valueLabel}}</h1>
        <h4 v-else>{{ value + ' ' + valueLabel}}</h4>
<!--        <span class="evaluationText">We are doing great!</span>-->
      </div>
    </div>
    <MessageModal :message="appMessage.text" :type="appMessage.type" ref="messageModal" />
  </div>
</template>

<script>
import MessageModal from "@/components/MessageModal.vue";

export default {
  name: "GaugeComponent",
  components: {MessageModal },
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    min: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
    valueLabel: {
      type: String,
      required: false,
      default: '',
    },
    smallValue: {
      type: Boolean,
      required: false,
      default: false,
    },
    showFooter: {
      type: Boolean,
      required: false,
      default: false,
    },
    compact: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      appMessage: {
        text: '',
        type: 'error',
      },
    };
  },
  watch: {
    value() {
      this.$nextTick(() => {
        this.placeAndOrientPin();
      });
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(this.placeAndOrientPin, 10)
    });

    window.addEventListener('resize', this.placeAndOrientPin);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.placeAndOrientPin);
  },
  methods: {
    placeAndOrientPin() {
      const gaugeOutline = document.getElementById("gaugeOutline" + this.value);
      const gaugePin = document.getElementById("gaugePin" + this.value);
      const gauge = document.getElementById("gauge" + this.value);

      const adjustGaugePin = () => {
        if (!gaugePin || !gauge) return;

        gaugePin.style.height = `${gauge.offsetHeight * 0.7}px`;
        gaugePin.style.left = `${(gauge.offsetWidth / 2) - (gaugePin.offsetWidth / 2)}px`;
        gaugePin.style.opacity = '1'

        let actualValue = this.value;
        if (actualValue < this.min) {
          this.appMessage.text = `Gauge value ${this.value} is below the minimum of ${this.min}.`;
          this.appMessage.type = 'error'
          this.$refs.messageModal.open()
          actualValue = this.min;
        } else if (actualValue > this.max) {
          this.appMessage.text = `Gauge value ${this.value} is above the maximum of ${this.max}.`;
          this.appMessage.type = 'error'
          this.$refs.messageModal.open()
          actualValue = this.max;
        }

        const range = this.max - this.min;
        const offset = actualValue - this.min;
        const percentage = offset / range;
        const angle = (180 * percentage) - 90;

        console.log(this.value, angle)

        gaugePin.style.transform = `rotate(${angle}deg)`;
      };

      if (gaugeOutline.complete) {
        adjustGaugePin();
      } else {
        gaugeOutline.addEventListener("load", adjustGaugePin);
      }
    },
  },
};
</script>

<style scoped>
h4{
  width: 100%;
  text-align: center;
  margin: 10px 0;
}
.evaluationText {
  font-family: "Oxanium", "Inter", sans-serif;
  color: var(--text-primary);
  font-size: 20px;
  font-weight: 400;
}
.gaugeFooter {
  text-align: right;
}
.gaugeOutline {
  width: 75%;
}
.gaugePin {
  position: absolute;
  bottom: 0;
  transform-origin: 50% 90%;
  transform: rotate(-90deg);
  transition: transform 1s ease-out;
  opacity: 1;
}
.gaugeHeader {
  display: flex;
  align-items: flex-start;
  gap: 15px;
}
.gauge {
  position: relative;
}
.icon {
  color: var(--text-primary);
  font-size: 30px;
}
.gaugeContainer {
  background-color: var(--color-card);
  border: 1px solid var(--color-card-border);
  padding: 15px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  box-shadow: var(--shadow-card);
  transition: all 0.3s ease;
}

.gaugeContainer:hover {
  box-shadow: var(--shadow-hover);
}

.gaugeContainer.gauge-compact {
  flex-direction: row;
  align-items: center;
  padding: 20px;
}

.gauge-compact .gauge {
  max-width: 150px;
  flex-shrink: 0;
}

.gauge-compact .gaugeHeader {
  flex: 1;
  margin-left: 20px;
}

.gauge-compact .gaugeFooter {
  text-align: left;
  margin-left: 20px;
}
</style>
